import React, {useMemo} from "react";
import apiService from "../../../../../../api/apiService";
import {useQuery} from "react-query";
import {blueprintCategory} from "../../../../../../utils/const/query-key";
import styled from "styled-components";
import Loading from "../../../../Loading";

const Image = styled.img`
  width: 15px;
`;

const BlueprintIcon = ({row}) => {
    const {data: bluePrintData, status} = useQuery(blueprintCategory, () =>
        apiService.getBlueprintCategoryData()
    );

    const categoryId = row.original.categoryId;
    const content = useMemo(() => {
        const matchingBp = bluePrintData?.find((bp) => bp.id === categoryId);
        return matchingBp && <Image src={matchingBp.icon}/>;
    }, [bluePrintData, categoryId]);
    if(status === 'loading'){
        return <Loading/>;
    }
    return content;
};

export default BlueprintIcon;
